import configs from '~/utils/configs';

export type PaymentMode = 'sandbox' | 'production' | 'disabled';

export interface PaymentConfig {
    mode: PaymentMode;
    zeusBase: string;
    zeusIpcode: string;
}

const loadScript = (src: string): Promise<void> =>
    new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.src = src;
        el.async = false;
        el.onload = () => resolve();
        el.onerror = () => reject(new Error(`Failed to load: ${src}`));
        document.head.appendChild(el);
    });

const loadCss = (href: string) => {
    const el = document.createElement('link');
    el.rel = 'stylesheet';
    el.href = href;
    document.head.appendChild(el);
};

export const loadZeusPayment = async (): Promise<PaymentConfig> => {
    const res = await fetch(`${configs.appConfig.API_URL}/payment-config`);
    if (!res.ok) throw new Error(`payment-config HTTP ${res.status}`);
    const body = await res.json();
    const cfg: PaymentConfig = body.data;

    window.paymentMode = cfg.mode;
    window.zeusTokenIpcode = cfg.zeusIpcode;

    console.info(`[Payment] Mode: ${cfg.mode} | ZEUS base: ${cfg.zeusBase || '(disabled)'}`);

    if (cfg.mode === 'disabled' || !cfg.zeusBase) return cfg;

    loadCss(`${cfg.zeusBase}/api/token/1.0/zeus_token.css`);
    await loadScript(`${cfg.zeusBase}/api/3ds2/3ds-web-wrapper.js`);

    return cfg;
};
